<template>
  <div class="c-order-entry c-symbol-panel">
    <c-incremental-search
      ref="incrementalSearch"
      class="c-order-entry-symbol"
      size="md"
      :ric="ric"
      :ticker="ticker"
      :country="country"
      :disabled="!isSymbolEnabled"
      :label="$t('white-label.globalLabels.symbol')"
      :instrumentTypes="['STO', 'FUN', 'BON', 'WAR', 'CER']"
      @change="onChange"
      @error="onSymbolSearchError"
    />
    <v-dropdown
      variant="primary"
      class="ticket-type"
      :aria-label="getAriaText()"
      :value="ticketType"
      :text="ticketTypeText"
      :disabled="!isTicketTypeEnabled"
    >
      <v-dropdown-item
        v-for="item in ticketTypeOptions"
        :key="item.value"
        :value="item.value"
        :active="item.value === ticketType"
        @click="$emit('ticket-type-changed', item.value)"
      >
        {{ item.long }}
      </v-dropdown-item>
    </v-dropdown>
    <w-order-entry-quick-info :wid="wid" :ric="ric" @fractional-symbol="fractionalSymbol"></w-order-entry-quick-info>
  </div>
</template>

<script>
import CIncrementalSearch from '@custom/CIncrementalSearch';
import WOrderEntryQuickInfo from '@widgets/WOrderEntryWidget/WOrderEntryQuickInfo';

export default {
  name: 'w-order-entry-symbol-panel',
  components: {
    CIncrementalSearch,
    WOrderEntryQuickInfo
  },
  inject: ['onSymbolSearchError'],
  props: {
    wid: {
      type: String,
      required: true
    },
    ric: {
      type: String
    },
    ticker: {
      type: String
    },
    country: {
      type: String
    },
    ticketType: {
      type: String,
      required: true
    },
    ticketTypeOptions: {
      required: true
    },
    isTicketTypeEnabled: {
      type: Boolean,
      default: true
    },
    isSymbolEnabled: {
      type: Boolean,
      default: true
    },
    eligible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ticketTypeText() {
      let text;
      this.ticketTypeOptions.forEach(option => {
        if (this.ticketType === option.value) {
          text = option.short;
        }
      });
      return text;
    }
  },
  methods: {
    clear() {
      this.$refs.incrementalSearch.clear();
    },
    i18n(subkey) {
      return this.$t(`white-label.${'widgets.orderEntry'}.${subkey}`);
    },
    onChange($event) {
      this.$emit('change', $event);
    },
    getAriaText() {
      let ariaStatement = this.ticketType;
      if (!this.eligible) {
        ariaStatement = ariaStatement.concat(this.$t(`white-label.widgets.orderEntry.controlbar.ineligible`));
      }
      return ariaStatement;
    },
    fractionalSymbol(value) {
      this.$emit('fractional-symbol', value);
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-order-entry-symbol';
</style>
